import { PlatformInfra } from '@wix/editor-platform-worker';
import {
  DocumentServices,
  HostAPI,
  HostAPIClassic,
  HostAPIEditorX,
  HostAPIStudio,
  HostType,
  HostAPIEditor3,
} from '@wix/editor-platform-private-api';
import {
  createEditorPlatformInternalError,
  EditorPlatformInternalErrorCode,
} from '@wix/public-editor-platform-errors';
import { IExperimentsApiAdapter } from '../utils/experimentsApiAdapter';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';
import { IEditorPlatformPackagesBridge } from '@wix/editor-platform-interfaces';

const getHostAPI = <THostType extends HostType>(
  hostType: THostType,
  platformApiMethods: PlatformApiMethods,
  documentServicesAPI: DocumentServices,
): HostAPI => {
  switch (hostType) {
    case HostType.Classic:
      return new HostAPIClassic(
        platformApiMethods,
        documentServicesAPI,
      ) as unknown as HostAPI;
    case HostType.Editorx:
      return new HostAPIEditorX(
        platformApiMethods,
        documentServicesAPI,
      ) as unknown as HostAPI;
    case HostType.Studio:
    case HostType.MobileStudio:
    case HostType.Blocks:
      return new HostAPIStudio(
        platformApiMethods,
        documentServicesAPI,
      ) as unknown as HostAPI;
    case HostType.Studio2:
    case HostType.Editor3:
      return new HostAPIEditor3(
        platformApiMethods,
        documentServicesAPI,
      ) as unknown as HostAPI;
    default:
      throw createEditorPlatformInternalError(
        EditorPlatformInternalErrorCode.UnexpectedError,
      ).withHost(hostType);
  }
};

export function initNewPlatformInfra({
  host,
  __temporaryPlatformApiMethods,
  documentServicesAPI,
  experimentsAPI,
  editorPlatformPackagesBridge,
}: {
  host: HostType;
  documentServicesAPI: DocumentServices;
  experimentsAPI: IExperimentsApiAdapter;
  __temporaryPlatformApiMethods: PlatformApiMethods;
  editorPlatformPackagesBridge: Partial<IEditorPlatformPackagesBridge>;
}) {
  if (!Object.values(HostType).includes(host)) {
    throw createEditorPlatformInternalError(
      EditorPlatformInternalErrorCode.UnexpectedError,
      `Could not determine host type`,
    ).withHost(host);
  }

  return new PlatformInfra(host, {
    hostAPI: getHostAPI(
      host,
      __temporaryPlatformApiMethods,
      documentServicesAPI,
    ),
    documentServicesAPI,
    // @ts-expect-error ...
    experimentsAPI,
    editorPlatformPackagesBridge,
  });
}
